import { Navigate, useLocation } from 'react-router-dom'
import useAuthStore from '@/stores/authStore'

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, user } = useAuthStore()
  const location = useLocation()

  if (!isAuthenticated) {
    // Redirect to login page with return url
    return <Navigate to="/auth/login" state={{ from: location }} replace />
  }

  // Check if user has admin or super_admin role
  if (!['admin', 'super_admin'].includes(user?.role)) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-2xl font-bold text-gray-900 mb-4">Access Denied</h1>
          <p className="text-gray-600">You don't have permission to access this area.</p>
        </div>
      </div>
    )
  }

  return children
}

export default ProtectedRoute